import { Document, PropertyFull, Detail } from '../../types';

/**
 * Gets the value of a detail by its code from a document or property.
 */
export const getDetailValue = (entity: Document | PropertyFull | { details: Detail[] }, code: string): any => {
    const detail = entity.details?.find(d => d.code === code);
    return detail ? detail.value : undefined;
};

/**
 * Gets the display name of a detail by its code.
 */
export const getDetailName = (entity: Document | PropertyFull | { details: Detail[] }, code: string): string | undefined => {
    const detail = entity.details?.find(d => d.code === code);
    return detail ? detail.name : undefined;
};

/**
 * Gets the ETL status of a document.
 */
export const getEtlStatus = (doc: Document): string => {
    return getDetailValue(doc, 'etl_status') || 'none';
};

/**
 * Gets the verification status of a document.
 */
export const getVerificationStatus = (doc: Document): string => {
    if (getEtlStatus(doc) === 'none') return 'verified';
    return getDetailValue(doc, 'verification_status') || 'pending';
};

/**
 * Gets the territory of a document.
 */
export const getTerritory = (doc: Document): string | undefined => {
    return getDetailValue(doc, 'territory');
};

/**
 * Gets the unit of a property.
 */
export const getPropertyUnit = (prop: PropertyFull): string | undefined => {
    return getDetailValue(prop, 'unit');
};
